import React, { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import { DatePicker } from 'antd';
import Loader from "../components/Loader";
import Error from "../components/Error";
import { Modal, Button, Carousel } from "react-bootstrap";
import withAuthRedirect from "../components/withAuthRedirect";


function Bookingscreen({ match }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [room, setRoom] = useState({});
  const [receivedDate, setReceivedDate] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalDays, setTotalDays] = useState(0);
  const dateHandleClose = () => setDateShow(false);
  const [fromdate, setFromDate] = useState(null);
  const [todate, setToDate] = useState(null);
  const [dateShow, setDateShow] = useState(true);
  const handleDateChange = (dates) => {
  const [start, end] = dates;
  setFromDate(start);
  setToDate(end);
};
  // const [bookingData, setBookingData] = useState(null);
  // const history = useHistory();
  const roomid =match.params.roomid;
  // const fromdate = moment(match.params.fromdate, "YYYY-MM-DD");
  // const todate = moment(match.params.todate, "YYYY-MM-DD");

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("currentUser"));
    if (!user) {
      sessionStorage.setItem('redirectUrl', window.location.pathname);
      window.location.href = "/login";
    }
    async function fetchMyAPI() {
      try {
        setError("");
        setLoading(true);
        const trimmedRoomId = roomid.trim();
        const data = (
          await axios.post("/api/rooms/getroombyid", {
            roomid: trimmedRoomId
          })
        ).data;
        //console.log(data);
        setRoom(data);
      } catch (error) {
        console.log(error);
        setError(error);
      }
      setLoading(false);
    }

    fetchMyAPI();
  }, [roomid]);


  useEffect(() => {
    async function fetchDatesApi() {
      try {
        setError("");
        setLoading(true);
        const trimmedRoomId = roomid.trim();
        const data = (
          await axios.post(`/api/bookings/availableDates`, {
            roomid:trimmedRoomId
          })
        ).data;
        //console.log(data);
        setReceivedDate(data.availableDates);
        console.log(data);
      } catch (error) {
        console.log(error);
        setError(error);
      }
      setLoading(false);
    }

    fetchDatesApi();
  }, [roomid]);

// const disabledDate = (current) => {
//     // Check if the current date is in the received dates array
//   //   if (current < moment().startOf('day')) {
//   //     console.log(current,"Curent")
//   //   return true;
//   // }
//     const formattedCurrentDate = current.format('YYYY-MM-DD');
//     console.log(formattedCurrentDate,"Formatted");
//     const returndisabledDates = receivedDate.some((date) => date === formattedCurrentDate);
//     console.log(returndisabledDates);
//     return returndisabledDates;
//   };

function disabledDate(current) {

      // Check if the current date is in the received dates array
    if (current < moment().startOf('day')) {
      console.log(current,"Curent")
    return true;
  }
  const currentDate = current.format('YYYY-MM-DD');
  // Disable dates that are not in the availableDates array
  return !receivedDate.includes(currentDate);
}

 useEffect(() => {
  if (todate && fromdate) {
    const totaldays = moment.duration(todate.diff(fromdate)).asDays() + 1;
    setTotalDays(totaldays);
    setTotalAmount(totaldays * room.rentperday);
  }
}, [todate, fromdate]);


  const handlePayment = async () => {
    const bookingDetails = {
      room,
      userid: JSON.parse(localStorage.getItem("currentUser"))._id,
      fromdate,
      todate,
      totalAmount,
      totaldays: totalDays,
    };

    try {
      setLoading(true);
      const result = await axios.post("/api/bookings/bookroom", bookingDetails);
      console.log(result);
      const pid=result.data.params.pid;
      const tAmt = result.data.params.tAmt;
      setLoading(false);
      
      Swal.fire({
        title: 'Please wait...',
        text: 'Your Room has been Reserved ',
        icon: 'info',
        timer: 3000, // milliseconds
        timerProgressBar: true,
        onBeforeOpen: () => {
          Swal.showLoading()
        },
        }
      ).then(() => {
        const url = `/esewaform?pid=${pid}&tAmt=${tAmt}&amt=${tAmt}`;
        window.location.href = url;
      });
    } catch (error) {
      setError(error);
      Swal.fire("Opps", "Error:" + error, "error");
    }
    setLoading(false);
  };

  const handleDatePickerFocus = (event) => {
    event.preventDefault();
  };

  const handleProceed = () => {
    if (fromdate && todate) {
        setDateShow(false);
    }
  };


  return (
    <div className="m-5">
      {loading ? (
        <Loader></Loader>
      ) : error.length > 0 ? (
        <Error msg={error}></Error>
      ) : (
        <>
        <Modal show={dateShow} onCancel={dateHandleClose} onHide={dateHandleClose} size="lg" footer={null}>
            <Modal.Header>
              <Modal.Title>Please Choose Date: </Modal.Title>
            </Modal.Header>
            <Modal.Body>
          <DatePicker.RangePicker onChange={handleDateChange} disabledDate={disabledDate} inputReadOnly onFocus={handleDatePickerFocus} />
          </Modal.Body>
          <Modal.Footer>
          <Button variant="secondary" onClick={handleProceed} disabled={!fromdate || !todate}>
            Proceed
          </Button>
          </Modal.Footer>
        </Modal>
        <div className="row justify-content-center mt-5 bs">
              <div className="col-md-6">
                <h1>{room.name}</h1>
                {/* <img src={room.imageurls[0]} alt="" className="bigimg" /> */}
                <Carousel prevLabel="" nextLabel="">
                  {room.imageurls && room.imageurls.length > 0 ? (
                  room.imageurls.map((url, index) => {
                    return (
                      <Carousel.Item key={index}>
                        <img
                          className="d-block w-100 h-100 bigimg"
                          src={url}
                          alt="First slide" />
                      </Carousel.Item>
                    );
                  })
                ) : (
                    <Carousel.Item>
                      <img
                        className="d-block w-100 h-100 bigimg"
                        src=""
                        alt="No Image"
                      />
                    </Carousel.Item>
                )}
                </Carousel>
              </div>
              <div className="col-md-6">
                <div style={{}}>
                  {/* textAlign: "center" */}
                  <h1>Booking Details</h1>
                  <hr />
                  <b>
                    <p>
                      Name : {JSON.parse(localStorage.getItem("currentUser")).name}
                    </p>
                    <p>From Date : {fromdate && fromdate.toISOString().split('T')[0]}</p>
                    <p>To Date : {todate && todate.toISOString().split('T')[0]}</p>
                    <p>Max Count : {room.maxcount}</p>
                  </b>
                </div>
                <div style={{ marginTop: 100 }}>
                  <h1>Amount</h1>
                  <hr />
                  <b>
                    <p>Total Days : {totalDays}</p>
                    <p>Rent per day : {room.rentperday}</p>
                    <p className="italic-green">Total Amount : Rs. {totalAmount}</p>
                  </b>
                </div>
                <div>
                  {/* <EsewaPayment /> */}
                  {/* Add other components and elements here //////////////////////////////////////ESEWA/////////////////////*/}
                </div>

                <div style={{ float: "right", marginTop: 20 }}>
                  <button className="btn btn-primary" onClick={handlePayment}>Pay Now</button>
                </div>
              </div>
            </div></>
        
      )}
    </div>
  );

}

export default withAuthRedirect(Bookingscreen);
